import React, { useEffect, useRef, useState, useMemo, useCallback, memo, useContext } from "react";
import { UserWalletDashboard } from "../../Pages/All/UserWalletDashboard.jsx";
import { GameDetails } from './GameDetails.jsx';
import { GameSmall } from "./GameSmall.jsx";
import UtrkeWidgetTab from "./UtrkeWidgetTab.jsx";
import { WebSocketContext } from "./WSContext.jsx";

// SVG prsten napretka (geometrija iz figma Ellipse110.svg): viewBox 20x20, centar (10,10).
const RING_RADIUS = 8.71;
const RING_CIRCUMFERENCE = 2 * Math.PI * RING_RADIUS;


class GameDetailsErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, info) {
        console.error("GameDetails crashed while showing a similar game:", error, info);
    }
    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
            this.setState({ hasError: false });
        }
    }
    render() {
        return this.state.hasError ? null : this.props.children;
    }
}

const removeGameFrameListeners = () => {
    const gameFrame = document.getElementById("gameFrame");
    if (gameFrame) {
        const clone = gameFrame.cloneNode(true);
        gameFrame.parentNode.replaceChild(clone, gameFrame);
    }
};

const handleLoginClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    removeGameFrameListeners();
    window.location.href = "https://mcasino.supersport.hr/login";
};

const handleRegisterClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    removeGameFrameListeners();
    window.location.href = "https://m.supersport.hr/registracija";
};

const getAmountClass = (amount) =>
    amount < 100 ? "bronze" : amount < 1000 ? "silver" : "gold";


const KEEPS_OWN_FOCUS = 'input, textarea, select, [contenteditable="true"], .input-iznos';

const keepsOwnFocus = (el) => !!(el && el.closest && el.closest(KEEPS_OWN_FOCUS));

const refocusGameFrame = () => {
    requestAnimationFrame(() => {
        if (keepsOwnFocus(document.activeElement)) return;
        document.getElementById("gameFrame")?.contentWindow?.focus();
    });
};



const isDarkMode = () => {
    // za sad samo light mode dok ne popravim
    //const casinoTheme = localStorage.getItem("darkModeStrategy") || "light";
    const casinoTheme = "light"
    if (casinoTheme === "system") {
        return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? true : false;
    } else {
        return casinoTheme === "dark";
    }
};

const UserWallet = (props) => {
    return (
        <div className="wallet-container">
            <UserWalletDashboard {...props} activeTab={props.novcanikTab} isFromWidget={true} />
        </div>
    );
};

const Winners = memo(({ gameInfo }) => {
    return (
        <div className="container-promo">
            <div className="title">Dobici u igri</div>
            <div className="title-2">Najveći dobici u igri</div>
            {gameInfo && gameInfo.najveciDobici && gameInfo.najveciDobici.length > 0 ? (
                gameInfo.najveciDobici.map((dobitak, index) => (
                    <div className="winner-row" key={index}>
                        <div className="left">
                            <div className="user">{dobitak.imeZaPrikaz}</div>
                            <div className="date">{dobitak.datumZaPrikaz}</div>
                        </div>
                        <div className="right">
                            <div className={"amount " + getAmountClass(dobitak.dobitakEuro)}>
                                {casino.utils.numberWithCurrencyFromated(dobitak.dobitakEuro, "EUR")}
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p className="desc">Nema dostupnih dobitaka za ovu igru.</p>
            )}
            <div className="title-2">Posljednja 24 sata</div>

            {gameInfo &&
                gameInfo.najveciDobici &&
                gameInfo.posljednjiDobici.length > 0 ? (
                gameInfo.posljednjiDobici.map((dobitak, index) => (
                    <div className="winner-row" key={index}>
                        <div className="left">
                            <div className="user">{dobitak.imeZaPrikaz}</div>
                            <div className="date">{dobitak.datumZaPrikaz}</div>
                        </div>
                        <div className="right">
                            <div className={"amount " + getAmountClass(dobitak.dobitakEuro)}>
                                {casino.utils.numberWithCurrencyFromated(dobitak.dobitakEuro, "EUR",)}
                            </div>
                        </div>
                    </div>
                ))
            ) : (
                <p className="desc">Nema dostupnih dobitaka za ovu igru.</p>
            )}
        </div>
    );
});

const FlickityCarouselSimilarGames = memo((props) => {
    const filteredGames = useMemo(() => {
        if (!props.brands || !props.gamecode || !props.games || !props.similarGames) return [];
        return props.similarGames.reduce((acc, similarGame) => {
            const game = props.games.find(x => x.s === similarGame.sifraMobile && x.s !== props.gamecode);
            if (game) acc.push(game);
            return acc;
        }, []);
    }, [props.brands, props.gamecode, props.games, props.similarGames]);

    return (
        <div className="horizontal-items v3 similar-games-row">
            <div className="horizontal-items--container clearfix mojcasino-padding v3">
                {filteredGames.map(game => (
                    <div key={game.s} className="relative">
                        <GameSmall
                            igra={game}
                            brands={props.brands}
                            routePrefix={props.routePrefix}
                            onCardClick={props.onGameSelect}
                            showGameName={true}
                            goLazyImage={false}
                            showJackpot={true}
                            iconImage={true}
                            isVerticalImage={false}
                            extraClass={""}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
});

const Info = ({ gameInfo, game, games, brands, user, toggleFavoritGameFn, gameRoutePrefix, onGameSelect }) => {
    let provider = brands[game.bID] ? brands[game.bID] : null;
    let providerImgUrl = provider && (casino.config.gameImagesUrl + provider.nameNormalizirano + '/logos/logo' + '.png' + '?c=' + casino.config.guiCacheVerzija);
    let isFavorite = user && user.favoriti.indexOf(game.id) === -1 ? false : true;
    let gameInfoLink = `https://mcasino.supersport.hr/game/${provider.nameNormalizirano}/${casino.utils.normalizeString(game.n)}/info`;

    const toggleFavoritGame = () => {
        toggleFavoritGameFn(game);
    };

    return (
        <>
            <div className="container-promo">
                <div className="title">Info igre</div>
                <div className="title-2">{game.n}</div>
                {game.jp && (
                    <div className="jackpot-info">
                        <span className="jackpot-icon"></span>
                        <div className="jackpot-amount">
                            {casino.utils.numberWithCurrencyFromated(game.jp, "EUR")}
                        </div>
                    </div>
                )}
                {gameInfo.liveRTP > 0 && (
                    <div className="info-row">
                        <span className="label">Live RTP</span>
                        <span className="value">
                            <span className={gameInfo.liveRTP > 100 ? "rtp green" : "rtp"}>
                                {gameInfo.liveRTP}%
                                <span className="rtp-icon"></span>
                            </span>
                        </span>
                    </div>
                )}
                {gameInfo.brojIgraca >= 0 && (
                    <div className="info-row">
                        <span className="label">Broj igrača</span>
                        <span className="value">
                            <span className={"players"}>
                                <span className="user-icon"></span>
                                {gameInfo.brojIgraca}
                            </span>
                        </span>
                    </div>
                )}
                {gameInfo.opis &&
                    <div className="info-row" onClick={() => window.open(gameInfoLink)}>
                        <span className="label">Saznaj više o igri</span>
                        <span className="value">
                            <span className="chevron-right-icon"></span>
                        </span>
                    </div>}
                {user && <div className="info-row" onClick={toggleFavoritGame}>
                    <span className="label">
                        {isFavorite ? "Ukloni iz favorita" : "Dodaj u favorite"}</span>
                    <span className="value">
                        <span className={`favorite-icon ${isFavorite ? "active" : ""}`}></span>
                    </span>
                </div>}
                {gameInfo.similarGames && gameInfo.similarGames.length > 0 && <>
                    <div className="divider mt-0"></div>
                    <div className="title-3 mb-12">Zaigraj slične igre</div>
                    <FlickityCarouselSimilarGames gamecode={gameInfo?.sifraIgre} similarGames={gameInfo?.similarGames} games={games} brands={brands} routePrefix={gameRoutePrefix} onGameSelect={onGameSelect} />
                </>}
                <div className="divider mt-0"></div>
                <div className="title-3 mb-12">Provider</div>
                <a href={`https://mcasino.supersport.hr/provideri?provider=${provider.nameNormalizirano}`} className="provider-link">
                    <img className="provider-logo" src={providerImgUrl} alt={provider.name} />
                </a>
            </div>


        </>
    );
};

const UserPromo = memo(() => {
    return (
        <div className="container-promo">
            <div className="title">Novčanik</div>

            <div className="title-2">Prijavi se za sudjelovanje</div>
            <p className="desc">
                Prijavi se kako bi mogao sudjelovati u Super Promocijama, Super
                Turnirima, igrati za prave dobitke i ostavajati super nagrade.
            </p>
            <div className="login-or-register">
                <a className="login-btn" href="#" onClick={handleLoginClick}>
                    Prijava
                </a>
                <a className="register-btn" href="#" onClick={handleRegisterClick}>
                    Registracija
                </a>
            </div>
            <div className="divider"></div>
            <div className="promo-steps">
                <div className="promo-steps-title">Bonus za registraciju</div>
                <div className="promo-step promo-step-1 border-bottom">
                    <span className="step-icon"></span>
                    <div className="step-text">
                        <div className="text-1">Registriraj se</div>
                        <div className="text-2">Osvoji 100 BESPLATNIH VRTNJI</div>
                    </div>
                </div>
                <div className="promo-step promo-step-2 border-bottom">
                    <span className="step-icon"></span>
                    <div className="step-text">
                        <div className="text-1">Uplata</div>
                        <div className="text-2">Osvoji 300 € BONUSA</div>
                    </div>
                </div>
                <div className="promo-step promo-step-3">
                    <span className="step-icon"></span>
                    <div className="step-text">
                        <div className="text-1">Uplati još</div>
                        <div className="text-2">Osvoji 400 BESPLATNIH VRTNJI</div>
                    </div>
                </div>
            </div>
        </div>
    );
});

const TournamentsPromo = memo(() => {
    return (
        <div className="container-promo">
            <div className="title">Turniri</div>
            <div className="tournament-lik"></div>
            <div className="title-2">Turniri te čekaju!</div>
            <p className="desc">
                Prijavi se kako bi vidio sve aktivne turnire. Igre i nagrade te čekaju.
                Provjeri sve i odaberi najbolju za tebe.
            </p>
        </div>
    );
});

const InGameModal = memo(({ visible, onClose, gameId, gameInfo, game, games, brands, activeTab, setActiveTab, connectionError, novcanikTab, setNovcanikTab, ...props }) => {
    const selectTab = (tab) => {
        const modalContent = document.getElementById("in-game-modal-content");
        if (modalContent) modalContent.scrollTop = 0;
        setActiveTab(tab);
    };

    return (
        <div
            className={"in-game-modal-overlay" + (visible ? " visible" : "") + (isDarkMode() ? " dark-mode" : "")}
            onClick={onClose}
        >
            <div id="in-game-modal" className={"in-game-modal"} onClick={(e) => e.stopPropagation()}>
                <div className="in-game-modal-header">
                    <span className="close-icon" onClick={onClose}></span>
                    <span className="supercasino-logo"></span>
                    <div className="in-game-tabs">
                        <span
                            className={"tab wallet " + (activeTab === 1 ? "active" : "")}
                            onClick={() => selectTab(1)}
                        >
                            <span className="tab-icon"></span>
                        </span>
                        {!connectionError && <span
                            className={"tab tournament " + (activeTab === 2 ? "active" : "")}
                            onClick={() => selectTab(2)}
                        >
                            <span className="tab-icon"></span>
                        </span>}
                        {gameInfo && gameInfo.opis &&
                            <>
                                {<span
                                    className={"tab tournaments " + (activeTab === 3 ? "active" : "")}
                                    onClick={() => selectTab(3)}
                                >
                                    <span className="tab-icon"></span>
                                </span>}
                                <span
                                    className={"tab info " + (activeTab === 4 ? "active" : "")}
                                    onClick={() => selectTab(4)}
                                >
                                    <span className="tab-icon"></span>
                                </span>
                            </>}
                    </div>
                </div>

                <div className="in-game-modal-content" id="in-game-modal-content">
                    {activeTab === 1 && visible && props.user && <UserWallet {...props} novcanikTab={novcanikTab} onNovcanikTabChange={setNovcanikTab} />}
                    {activeTab === 1 && !props.user && <UserPromo {...props} />}
                    {activeTab === 2 && props.user && < UtrkeWidgetTab playerID={props.user.igracID} gameID={gameId} />}
                    {activeTab === 2 && !props.user && <TournamentsPromo />}
                    {activeTab === 3 && <Winners gameInfo={gameInfo} />}
                    {activeTab === 4 && <Info gameInfo={gameInfo} game={game} games={games} brands={brands} user={props.user} toggleFavoritGameFn={props.toggleFavoritGameFn} gameRoutePrefix={props.gameRoutePrefix} onGameSelect={props.onSimilarGameSelect} />}
                </div>
                <div className="top-rectangle"></div>

            </div>
        </div>
    );
});

const InGameWidget = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [game, setGame] = useState(null);
    const [gameInfo, setGameInfo] = useState(null);
    const [games, setGames] = useState(null);
    const [brands, setBrands] = useState(null);
    const [activeTab, setActiveTab] = useState(1);
    const [novcanikTab, setNovcanikTab] = useState("casino")
    const gameId = useMemo(() => new URLSearchParams(window.location.search).get("id"), []);
    const walletRef = useRef(null);


    const [ready, val, send, connectionError] = useContext(WebSocketContext);
    const [tournament, setTournament] = useState(null);
    const [myPositionState, setMyPositionState] = useState(null);
    const [remainingTime, setRemainingTime] = useState();
    const [tournamentProgress, setTournamentProgress] = useState(0);

    const [selectedSimilarGame, setSelectedSimilarGame] = useState(null);
    const similarGamePopupRef = useRef(null);
    const closeSimilarGame = useCallback(() => setSelectedSimilarGame(null), []);
    // Sintetički "route" - ne koristimo pravu URL rutu za ovaj popup (klik ne smije
    // mijenjati URL), pa GameDetails.jsx dobiva minimalan objekt oblika kakav inače
    // dobiva od react-router-a. history.push je jedini stvarni "izlaz" iz GameDetails
    // (swipe-to-close ga zove), pa ga preusmjeravamo na zatvaranje popupa lokalno.
    const syntheticRoute = useMemo(() => ({
        location: { pathname: props.gameRoutePrefix || '', search: '', query: {} },
        match: { params: {} },
        history: { push: closeSimilarGame }
    }), [props.gameRoutePrefix, closeSimilarGame]);

    useEffect(() => {
        if (!selectedSimilarGame) return;

        // GameDetails/GameDialog zatvaraju se preko internih <NavLink>-ova (X ikona,
        // pozadina popupa) koji inače rade pravu navigaciju - to bismo vidjeli kao
        // promjenu URL-a. Presrećemo klik prije nego NavLink stigne navigirati i umjesto
        // toga samo zatvaramo popup lokalno (isto ponašanje, bez ikakve navigacije).
        const handleCloseClick = (e) => {
            const wrapper = similarGamePopupRef.current;
            if (!wrapper) return;
            const closeTarget = e.target.closest('.close-overlay, .modal-dialog-overlay a, .game-dialog-header .link-1');
            if (closeTarget && wrapper.contains(closeTarget)) {
                e.preventDefault();
                e.stopPropagation();
                closeSimilarGame();
            }
        };
        document.addEventListener("click", handleCloseClick, { capture: true });
        return () => document.removeEventListener("click", handleCloseClick, { capture: true });
    }, [selectedSimilarGame, closeSimilarGame]);



    const getGames = () => {
        casino.repos.gameRepo.list().then((data) => {
            setGames(data.items);
            setBrands(data.brendovi);
            let game = data.items.find((g) => g.id === parseInt(gameId));
            setGame(game);
            if (game) {
                casino.repos.seoGameInfoRepo.get(game.s).then((seoData) => {
                    setGameInfo(seoData);
                });
            }
        });
    };

    useEffect(() => {
        // Play.cshtml (ova stranica) nema SEO <meta> tagove koje MetaTags.jsx bez provjere
        // čita/piše kad GameDetails prikaže popup za sličnu igru - ovdje ih samo osiguravamo
        // da postoje u <head>, da GameDetails/GameDialog mogu raditi nepromijenjeni.
        const ensureMetaTag = (selector, attrName, attrValue) => {
            if (!document.querySelector(selector)) {
                const el = document.createElement("meta");
                el.setAttribute(attrName, attrValue);
                el.setAttribute("content", "");
                document.head.appendChild(el);
            }
        };
        ensureMetaTag('meta[name="description"]', "name", "description");
        ensureMetaTag('meta[property="og:title"]', "property", "og:title");
        ensureMetaTag('meta[property="og:description"]', "property", "og:description");
        ensureMetaTag('meta[property="og:url"]', "property", "og:url");
        ensureMetaTag('meta[property="og:image"]', "property", "og:image");
    }, []);

    useEffect(() => {
        getGames();
        const controller = new AbortController();
        const modal = document.getElementById("in-game-modal");
        const modalContent = document.getElementById("in-game-modal-content");
        var modalTouchStart;
        var modalTouchEnd;
        var isAtBottom = false;

        // blur/focus on the iframe element itself is unreliable across browsers, but the
        // top-level window reliably fires "focus" whenever DOM focus moves from a child
        // frame (the game) back up to this document - that's exactly "iframe lost focus"
        const gameFrame = document.getElementById("gameFrame");

        // The tap target says where focus is headed before the browser puts it there,
        // which activeElement at "focus" time cannot. touchstart as well as pointerdown
        // because older iOS Safari has no pointer events.
        let lastPointerTarget = null;
        const recordPointerTarget = (e) => { lastPointerTarget = e.target; };
        document.addEventListener("pointerdown", recordPointerTarget, { capture: true, signal: controller.signal });
        document.addEventListener("touchstart", recordPointerTarget, { capture: true, signal: controller.signal });

        window.addEventListener("focus", () => {
            const active = document.activeElement;
            // don't steal focus from our own form controls (e.g. the deposit amount input)
            if (gameFrame && active !== gameFrame && !keepsOwnFocus(active) && !keepsOwnFocus(lastPointerTarget)) {
                refocusGameFrame();
            }
        }, { signal: controller.signal });

        modalContent.addEventListener("touchmove", (e) => {

            modalTouchEnd = e.targetTouches[0].clientY;


            var diff = modalTouchEnd - modalTouchStart;

            if (isAtBottom && diff < 0) {
                e.preventDefault();
                modal.style.transform = `translate3d(0 ,${diff}px , 0)`;
                modal.style.opacity = 1 + diff / 500;
            }
            { signal: controller.signal }
        })
        modalContent.addEventListener("touchstart", (e) => {
            isAtBottom = (Math.ceil(modalContent.scrollTop + modalContent.clientHeight) >= modalContent.scrollHeight - 2);
            modalTouchStart = e.targetTouches[0].clientY;
            modalTouchEnd = modalTouchStart;


        }, { signal: controller.signal })
        modalContent.addEventListener("touchend", (e) => {
            if (isAtBottom && (modalTouchStart - modalTouchEnd > 80)) {
                handleClose();
                setTimeout(() => {
                    modal.style.transform = "";
                    modal.style.opacity = "";
                }, 300)
            }
            else {
                modal.style.transform = "";
                modal.style.opacity = "";
            }
        }, { signal: controller.signal })

        return () => {
            controller.abort();
        }

    }, []);

    const handleClose = useCallback(() => setShowModal(false), []);
    const handleQuickMenuClick = useCallback(() => {
        setShowModal(true);
        setActiveTab(1);
    }, []);
    const handleTournamentClick = useCallback(() => {
        setShowModal(true);
        setActiveTab(2);
    }, []);

    useEffect(() => {
        if (ready && !connectionError && game && props.user) {
            send(JSON.stringify({ type: "subscribe", topic: "leaderboard", data: { gameID: game.id, playerID: props.user.igracID, statuses: [4, 5, 6] } }));
            send(JSON.stringify({ type: "tournaments", data: { playerID: props.user.igracID, limit: 50, gameID: game.id, statuses: [2, 4, 5, 6] } }));


        }
    }, [ready, connectionError, game, props.user])


    useEffect(() => {
        if (val != null) {
            parseData(val);
        }
    }, [val])


    useEffect(() => {
        // Odbrojavanje do pocetka turnira - prikazuje se samo dok je status "Uskoro pocinje" (2).
        if (!tournament || Number(tournament.status) !== 2) {
            setRemainingTime(null);
            return;
        }

        const tick = () => setRemainingTime(getCountdownToStart(tournament.startTimeUTC));
        tick();
        const interval = setInterval(tick, 1000);

        return () => clearInterval(interval);
    }, [tournament])


    useEffect(() => {
        // Napredak turnira (proteklo vrijeme) dok je aktivan - status 4,5. Krug se puni po 5%.
        const status = Number(tournament?.status);
        if (!tournament || (status !== 4 && status !== 5)) {
            return;
        }

        const tick = () => setTournamentProgress(getSteppedProgress(tournament.startTimeUTC, tournament.endTimeUTC));
        tick();
        const interval = setInterval(tick, 10000);

        return () => clearInterval(interval);
    }, [tournament])



    const parseData = (data) => {
        var x = JSON.parse(data);
        switch (x.type) {
            case "leaderboardResponse":
                setMyPositionState(x.data?.find(x => x.isMe)?.rank);
                break;
            case "tournamentResponse":
                setTournament(x.data[0]);
                break;
            case "tournamentStatusChanged":
                if (game && props.user) {
                    send(JSON.stringify({ type: "tournaments", data: { playerID: props.user.igracID, limit: 50, gameID: game.id, statuses: [2, 4, 5, 6] } }));
                }
                break;
            default:
                break;
        }

    }

    function getCountdownToStart(time) {
        const now = new Date();
        const start = new Date(time + 'Z');
        let diffSec = Math.floor((start - now) / 1000);
        if (diffSec <= 0) return "00:00";

        const hours = Math.floor(diffSec / 3600);
        diffSec -= hours * 3600;
        const minutes = Math.floor(diffSec / 60);
        const seconds = diffSec - minutes * 60;

        const pad = (n) => String(n).padStart(2, '0');
        return hours > 0
            ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
            : `${pad(minutes)}:${pad(seconds)}`;
    }

    function getSteppedProgress(start, end) {
        const startTime = new Date(start + 'Z');
        const endTime = new Date(end + 'Z');
        const total = endTime - startTime;
        if (total <= 0) return 100;

        const elapsed = new Date() - startTime;
        let pct = (elapsed / total) * 100;
        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;

        return Math.floor(pct / 5) * 5;
    }



    const tournamentStatus = tournament ? Number(tournament.status) : null;
    const pillColorClass =
        (tournamentStatus === 4 || tournamentStatus === 5) ? "green"
            : (tournamentStatus === 6) ? "grey"
                : "";

    return (
        <>
            <div className={"in-game-widget"}>
                <div className="quick-menu" onClick={handleQuickMenuClick}>
                    <span className="super-icon"></span>
                    <span className="menu-text">BRZI MENI</span>
                </div>
                {props.user && tournament && <div className={`tournament-menu ${pillColorClass}`} onClick={handleTournamentClick}>

                    {tournamentStatus === 2 && <>
                        <span className="time-icon"></span>
                        <div className="info-text">{remainingTime}</div>
                    </>}

                    {(tournamentStatus === 4 || tournamentStatus === 5) && <>
                        <span className="flag-icon"></span>
                        <div className="info-text">{myPositionState}</div>
                        <span className="progress-ring">
                            <svg className="progress-ring-svg" viewBox="0 0 20 20">
                                <circle className="progress-ring-track" cx="10" cy="10" r={RING_RADIUS} />
                                <circle
                                    className="progress-ring-fill"
                                    cx="10" cy="10" r={RING_RADIUS}
                                    strokeDasharray={RING_CIRCUMFERENCE}
                                    strokeDashoffset={RING_CIRCUMFERENCE * (1 - tournamentProgress / 100)}
                                    transform="rotate(-90 10 10)"
                                />
                            </svg>
                            <span className="clock-icon"></span>
                        </span>
                    </>}

                    {tournamentStatus === 6 && <>
                        <span className="flag-icon"></span>
                        <div className="info-text">{myPositionState}</div>
                        <span className="checkmark-icon"></span>
                    </>}
                </div>}
            </div>
            <InGameModal
                visible={showModal}
                onClose={handleClose}
                gameId={gameId}
                gameInfo={gameInfo}
                game={game}
                games={games}
                brands={brands}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                connectionError={connectionError}
                novcanikTab={novcanikTab}
                setNovcanikTab={setNovcanikTab}
                onSimilarGameSelect={setSelectedSimilarGame}
                {...props}
            />
            <GameDetailsErrorBoundary resetKey={selectedSimilarGame && selectedSimilarGame.id}>
                <div ref={similarGamePopupRef}>
                    <GameDetails
                        {...props}
                        route={syntheticRoute}
                        routePrefix={props.gameRoutePrefix}
                        igra={selectedSimilarGame}
                        igre={games}
                    />
                </div>
            </GameDetailsErrorBoundary>
        </>
    );
};

export default InGameWidget;
